const blogs = [
  {
    title: 'Membuat Otentikasi JWT dengan PHP Native',
    date: new Date('2020-11-16'),
    url:
      'https://medium.com/@itsfaqih/membuat-otentikasi-jwt-dengan-php-native-a9d080953358',
  },
  {
    title: 'Apa itu JWT (JSON Web Token)?',
    date: new Date('2020-11-14'),
    url: 'https://medium.com/@itsfaqih/apa-itu-jwt-json-web-token-63407936da10',
  },
  {
    title: 'Penerapan Sistem Grid Responsive dengan Flexbox',
    date: new Date('2020-06-13'),
    url:
      'https://medium.com/@itsfaqih/penerapan-sistem-grid-responsive-dengan-flexbox-c479c84be129',
  },
  {
    title: 'Memahami Satuan Persen (%) dalam CSS',
    date: new Date('2020-06-11'),
    url:
      'https://medium.com/@itsfaqih/memahami-satuan-persen-dalam-css-12479cba1c32',
  },
];

export default blogs;
